<!-- Branded splash while Auth0 restores the session / handles the callback -->
<div *ngIf="showSplash$ | async" class="advocad-splash">
  <div class="advocad-splash__blob advocad-splash__blob--1"></div>
  <div class="advocad-splash__blob advocad-splash__blob--2"></div>

  <div class="advocad-splash__inner">
    <div class="advocad-splash__logo-ring">
      <img
        src="assets/images/advocad-logo.svg"
        alt="Advocad"
        class="advocad-splash__logo"
      />
    </div>

    <!-- reach-meter bars: on-brand "measuring your reach" animation -->
    <div class="advocad-splash__bars" aria-hidden="true">
      <span></span><span></span><span></span><span></span><span></span>
    </div>

    <div class="advocad-splash__text">
      <p class="advocad-splash__title">Signing you in…</p>
      <p class="advocad-splash__sub">Getting your reach ready</p>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
